<template>
  <div>
    <div v-if="specials && specials.length">
      <!--- If a location have some special iems , display them on first---->
      <h4 id="special" v-if="depth == 0">Special</h4>
      <menu-item
          v-for="item in specials"
          :key="'special_' + item.id"
          :item="item.locationMenuItem"
          :specialStartDate="item.start_date"
          :specialEndDate="item.end_date"
          :cart="cart"
        ></menu-item>
    </div>
    <div v-if="categories && categories.length">
      <div v-for="cat in categories" :key="cat.id">
        <div v-if="cat.menu_items.length > 0 || cat.children.length">
          <h4 :id="'cat_' + cat.id" v-if="depth == 0">{{ cat.name }}</h4>
          <h5 v-if="depth == 1">{{ cat.name }}</h5>
          <h6 v-if="depth > 1">{{ cat.name }}</h6>
          <p class="cat-description">{{cat.description}}</p>
          <div v-if="cat.menu_items.length">
            <menu-item
              v-for="item in cat.menu_items"
              :key="item.id"
              :item="item"
              :cart="cart"
            ></menu-item>
          </div>
          <div v-if="cat.children.length">
            <menu-tree
              :depth="depth + 1"
              :categories="cat.children"
              :cart="cart"
            ></menu-tree>
          </div>
        </div>
      </div>
    </div>
    <div v-if="(!specials || !specials.length) && (!categories || !categories.length)">
      <empty-data
        icon-color="#FF6600"
        :message="isLoadingCategories ? $t('message.menu_is_loading') : msgEmpty"
        :icon="icon"
        :image="image"
        text-color="#000"
      ></empty-data>
    </div>
  </div>
</template>
<script>
import MenuItem from "@/views/components//MenuItem";
import EmptyData from "@/views/components/EmptyData";
import { mapGetters } from 'vuex'
export default {
  name: "menu-tree",
  components: {
    MenuItem,
    EmptyData
  },
  props: {
    categories: Array,
    specials:Array,
    item: Object,
    depth: Number,
    locationStatus: Object,
    msgEmpty: String,
    icon: String,
    cart: Object,
    image:String
  },
  computed:{
    ...mapGetters(["isLoadingCategories"])
  }
};
</script>
